import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Loading } from "src/components/Loading";
import { CookieNames, getCookie, setHeraCookie } from "src/helpers/cookies";
import { fromEnv } from "src/helpers/fromEnv";
import { useHistory } from "react-router-dom";
import {
  PassportStoreContext,
  usePassportStore,
} from "src/stores/Passport.store";

const redirectToHera = () =>
  (window.location.href = fromEnv("REACT_APP_HERA_HOST"));

const authUrl = `${fromEnv("REACT_APP_HERA_HOST")}/login`;

const redirectToHeraLogin = () => {
  setHeraCookie(CookieNames.CurrentPath, fromEnv("REACT_APP_HOST"));
  return (window.location.href = authUrl);
};

export const PassportAuthProvider = observer(({ children }: any) => {
  const { location, replace } = useHistory();
  const context = usePassportStore();
  const { loadingState, isAuthenticated, authUser, outlet } = context;

  const [initState, setInitState] = useState(false);
  const token = getCookie(CookieNames.HeraToken);

  useEffect(() => {
    context.setToken(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    (async () => {
      try {
        await context.getCurrentUser();
        await context.getUserOutlet();

        replace(location.pathname);
      } finally {
        setInitState(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading =
    loadingState.has.getCurrentUser ||
    loadingState.has.getUserOutlet ||
    !initState;

  if (isLoading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    redirectToHeraLogin();
    return <Loading />;
  }

  if (!authUser.isAdmin || !outlet.allowPassportOnboarding) {
    redirectToHera();
    return <Loading />;
  }

  return (
    <PassportStoreContext.Provider value={context}>
      {children}
    </PassportStoreContext.Provider>
  );
});
